import { k2UserSchema } from '@k2/common/users-state/normalizer-schemas';
import { schema } from 'normalizr';

export const clientSchema = new schema.Entity('clients', {
  account_director: k2UserSchema
});

export const clientsListSchema = new schema.Array(clientSchema);
